import Image2 from '../../assest/ahbaab/Cleanroom Consumables/Stainless Steel Tools/Stainless Steel Tools.jpg'
import Image3 from '../../assest/ahbaab/Cleanroom Consumables/Stainless Steel Tools/Workbench.jpg'
import Image4 from '../../assest/ahbaab/Cleanroom Consumables/writing accessories/Pen & Markers.jpg'
import Image5 from '../../assest/ahbaab/Cleanroom Consumables/writing accessories/Writing Accessories.jpg'
import Image6 from '../../assest/ahbaab/Cleanroom Consumables/Mats/Mats.jpg'
import Image7 from '../../assest/ahbaab/Cleanroom Protection/Eye & Respiratory/Googles.jpg'
import Image8 from '../../assest/ahbaab/Cleanroom Protection/Eye & Respiratory/Masks.jpg'
import Image9 from '../../assest/ahbaab/Cleanroom Protection/Garments/Garments.jpg'
import Image10 from '../../assest/ahbaab/Cleanroom Protection/Gloves/Gloves.jpg'
import Image11 from '../../assest/ahbaab/Cleanroom Protection/Socks & Shoes/Shoes.jpg'
import Image12 from '../../assest/ahbaab/Cleanroom Protection/Socks & Shoes/Socks.jpg'
import Image13 from '../../assest/ahbaab/Visual Inspection Kits/Manual Inspection & Defect Kits/Visual Inspection Kits.jpg'
import Image14 from '../../assest/ahbaab/Cleaning Accessories/Buckets & Trolley Systems/Buckes & Trolly System.jpg'
import Image15 from '../../assest/ahbaab/Cleaning Accessories/Mops/Mops.jpg'
import Image16 from '../../assest/ahbaab/Cleaning Accessories/Wipes/Wipes.jpg'
import Image17 from '../../assest/ahbaab/Cleaning Accessories/Wipes/Wipes2.jpg'



const OurProductData = [
  // ---------------- CLEANROOM CONSUMABLES ----------------
  {
    id: 1,
    heading: 'Cleanroom Consumables',
    linkTag: 'clean-room-consumables',
    imgSrc: Image6,
    category: [
      {
        categoryName: "Stainless Steel Tools",
        categoryId: "01",
        categoryLink: 'stainless-steel-tools',
        categoryImge: Image2,
        productCategory: [
          {
            productCategoryName: "Stainless Steel Tools",
            productCategoryId: "01",
            productCategoryLink: 'stainless-steel-tools',
            productCategoryImge: Image2,
            productCategoryDetail: [
              {
                productCategorytextInfo: "High-quality stainless steel tools designed for cleanroom environments. Resistant to corrosion and easy to sterilize.",
                productCategoryfeatures: [
                  "Made from high-grade stainless steel",
                  "Rust-proof and durable",
                  "Suitable for autoclave sterilization",
                  "Non-contaminating surfaces"
                ]
              }
            ]
          },
          {
            productCategoryName: "Workbench",
            productCategoryId: "02",
            productCategoryLink: 'workbench',
            productCategoryImge: Image3,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Ergonomically designed stainless steel workbenches to ensure safe and clean operations.",
                productCategoryfeatures: [
                  "Strong, durable build",
                  "Smooth finish for easy cleaning",
                  "Chemical resistant surface",
                  "Available in multiple sizes"
                ]
              }
            ]
          }
        ]
      },
      {
        categoryName: "Writing Accessories",
        categoryId: "02",
        categoryLink: 'writing-accessories',
        categoryImge: Image5,
        productCategory: [
          {
            productCategoryName: "Pens & Markers",
            productCategoryId: "01",
            productCategoryLink: 'pens-markers',
            productCategoryImge: Image4,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Cleanroom-approved pens and markers for reliable documentation without contamination risk.",
                productCategoryfeatures: [
                  "Low particle generation",
                  "Quick-dry ink",
                  "Available in multiple colors",
                  "Sterilizable packaging"
                ]
              }
            ]
          },
          {
            productCategoryName: "Writing Accessories",
            productCategoryId: "02",
            productCategoryLink: 'writing-accessories',
            productCategoryImge: Image5,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Complementary writing accessories including cleanroom notebooks and labels.",
                productCategoryfeatures: [
                  "Low linting materials",
                  "Durable covers",
                  "Cleanroom-safe adhesive labels",
                  "Ideal for documentation & tracking"
                ]
              }
            ]
          }
        ]
      },
      {
        categoryName: "Mats",
        categoryId: "03",
        categoryLink: 'mats',
        categoryImge: Image6,
        productCategory: [
          {
            productCategoryName: "Mats",
            productCategoryId: "01",
            productCategoryLink: 'mats',
            productCategoryImge: Image6,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Durable mats designed to trap dust and particles at cleanroom entrances.",
                productCategoryfeatures: [
                  "High particle retention",
                  "Durable and reusable",
                  "Slip-resistant base",
                  "Ideal for critical entry points"
                ]
              }
            ]
          },
        ]
      }
    ]
  },

  // ---------------- CLEANROOM PROTECTION ----------------
  {
    id: 2,
    heading: 'Cleanroom Protection',
    linkTag: 'clean-room-protection',
    imgSrc: Image7,
    category: [
      {
        categoryName: "Eye & Respiratory",
        categoryId: "01",
        categoryLink: 'eye-respiratory',
        categoryImge: Image7,
        productCategory: [
          {
            productCategoryName: "Goggles",
            productCategoryId: "01",
            productCategoryLink: 'goggles',
            productCategoryImge: Image7,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Protective goggles designed for cleanrooms to shield eyes from contaminants.",
                productCategoryfeatures: [
                  "Anti-fog and anti-scratch lenses",
                  "Comfortable fit for long use",
                  "Compatible with face masks",
                  "Sterilizable design"
                ]
              }
            ]
          },
          {
            productCategoryName: "Masks",
            productCategoryId: "02",
            productCategoryLink: 'masks',
            productCategoryImge: Image8,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Cleanroom masks designed to protect against airborne particles and contamination.",
                productCategoryfeatures: [
                  "Multi-layer filtration",
                  "Breathable material",
                  "Latex-free elastic bands",
                  "Available in multiple types (surgical, N95, etc.)"
                ]
              }
            ]
          }
        ]
      },
      {
        categoryName: "Garments",
        categoryId: "02",
        categoryLink: 'garments',
        categoryImge: Image9,
        productCategory: [
          {
            productCategoryName: "Garments",
            productCategoryId: "01",
            productCategoryLink: 'garments',
            productCategoryImge: Image9,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Full-body garments designed for maximum protection in cleanroom environments.",
                productCategoryfeatures: [
                  "Lint-free material",
                  "Durable zippers and seams",
                  "Comfortable fit",
                  "Available in multiple sizes"
                ]
              }
            ]
          },
        ]
      },
      {
        categoryName: "Gloves",
        categoryId: "03",
        categoryLink: 'gloves',
        categoryImge: Image10,
        productCategory: [
          {
            productCategoryName: "Gloves",
            productCategoryId: "01",
            productCategoryLink: 'gloves',
            productCategoryImge: Image10,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Cleanroom gloves to ensure contamination-free handling of sensitive products.",
                productCategoryfeatures: [
                  "Powder-free",
                  "High tactile sensitivity",
                  "Latex and nitrile options",
                  "Sterile and non-sterile variants"
                ]
              }
            ]
          },
        ]
      },
      {
        categoryName: "Socks & Shoes",
        categoryId: "04",
        categoryLink: 'socks-shoes',
        categoryImge: Image11,
        productCategory: [
          {
            productCategoryName: "Socks",
            productCategoryId: "01",
            productCategoryLink: 'socks',
            productCategoryImge: Image12,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Specially designed socks for cleanrooms to maintain hygiene and comfort.",
                productCategoryfeatures: [
                  "Made from lint-free materials",
                  "Comfortable elastic fit",
                  "Available in multiple sizes",
                  "Washable and reusable"
                ]
              }
            ]
          },
          {
            productCategoryName: "Shoes",
            productCategoryId: "02",
            productCategoryLink: 'shoes',
            productCategoryImge: Image11,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Cleanroom-safe shoes designed to provide protection and comfort.",
                productCategoryfeatures: [
                  "Slip-resistant sole",
                  "Easy to sterilize",
                  "Breathable material",
                  "Durable and long-lasting"
                ]
              }
            ]
          }
        ]
      }
    ]
  },

  // ---------------- VISUAL INSPECTION KITS ----------------
  {
    id: "03",
    heading: "Visual Inspection Kits",
    linkTag: "visual-inspection-kits",
    imgSrc: Image13,
    category: [
      {
        categoryName: "Manual Inspection & Defect Kits",
        categoryId: "01",
        categoryLink: 'manual-inspection-defect-kits',
        categoryImge: Image13,
        productCategory: [
          {
            productCategoryName: "Manual Inspection & Defect Kits",
            productCategoryId: "01",
            productCategoryLink: 'manual-inspection-defect-kits',
            productCategoryImge: Image13,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Magnifiers and lamps for detailed inspection.",
                productCategoryfeatures: [
                  "Handheld magnifiers",
                  "LED inspection lamps",
                  "Durable design",
                  "High clarity lenses"
                ]
              }
            ]
          },
        ]
      }
    ]
  },

  // ---------------- CLEANING ACCESSORIES ----------------
  {
    id: "04",
    heading: "Cleaning Accessories",
    linkTag: "cleaning-accessories",
    imgSrc: Image14,
    category: [
      {
        categoryName: "Buckets & Trolley Systems",
        categoryId: "01",
        categoryLink: 'buckets-trolleys',
        categoryImge: Image14,
        productCategory: [
          {
            productCategoryName: "Buckets & Trolley Systems",
            productCategoryId: "01",
            productCategoryLink: 'buckets-trolleys',
            productCategoryImge: Image14,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Buckets designed for cleanroom cleaning.",
                productCategoryfeatures: [
                  "Stainless steel buckets",
                  "Polypropylene buckets",
                  "Durable and reusable",
                  "Chemical-resistant"
                ]
              }
            ]
          },
         
        ]
      },
      {
        categoryName: "Mops",
        categoryId: "02",
        categoryLink: 'mops',
        categoryImge: Image15,
        productCategory: [
          {
            productCategoryName: "Mops",
            productCategoryId: "01",
            productCategoryLink: 'mops',
            productCategoryImge: Image15,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Cleanroom-safe flat mops.",
                productCategoryfeatures: [
                  "Disposable flat mops",
                  "Reusable flat mops",
                  "Washable material",
                  "Particle-free cleaning"
                ]
              }
            ]
          },
        ]
      },
      {
        categoryName: "Wipes",
        categoryId: "03",
        categoryLink: 'wipes',
        categoryImge: Image17,
        productCategory: [
          {
            productCategoryName: "Dry Wipes",
            productCategoryId: "01",
            productCategoryLink: 'dry-wipes',
            productCategoryImge: Image17,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Lint-free wipes for everyday use.",
                productCategoryfeatures: [
                  "Nonwoven wipes",
                  "Lint-free wipes",
                  "Soft and durable",
                  "Ideal for sensitive areas"
                ]
              }
            ]
          },
          {
            productCategoryName: "Pre-saturated Wipes",
            productCategoryId: "02",
            productCategoryLink: 'pre-saturated-wipes',
            productCategoryImge: Image16,
            productCategoryDetail: [
              {
                productCategorytextInfo: "Wipes with cleaning agents.",
                productCategoryfeatures: [
                  "IPA wipes",
                  "Disinfectant wipes",
                  "Ready to use",
                  "Safe for cleanrooms"
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];

export default OurProductData;
